import { trpc } from '@/shared/api/trpc';

export const useUpdateTourOperator = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateTourOperator.useMutation({
    onSettled: () => {
      utils.operations.tourOperatorsList.invalidate();
      utils.operations.tourOperatorAssignments.invalidate();
      // Same table backs the CRM tour-operators list — keep it fresh too.
      utils.tourOperators.list.invalidate();
      utils.tourOperators.filterCounts.invalidate();
      utils.tourOperators.countriesCities.invalidate();
    },
  });
};
